const doc = [({"da":({"js":({"layout":({"you_have_been_signed_out":"Du er blevet logget ud", "log_out":"Log af", "you_were_signed_out":"Du er blevet logget ud"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;